import React, {useState} from "react";

export function ContactComponent(props) {
    const [submitted, setSubmitted] = useState(false);
    const [userComment, setUserComment] = useState('');
    const [spinner, setSpinner] = useState(false);
    const { user, postUserFeedback, container } = props;
    const loggedUserEmail = (user !== null && user !== undefined) ? user.email : "anonymous@email.com";
    let [userEmail, setUserEmail] = useState(loggedUserEmail);

    /*
     * this stmt: ```userEmail = userEmail != null ? userEmail : loggedUserEmail;``` is very (very) important.
     * Without this stmt below, userEmail always initializes to undefined (even upon 'user' state being changed).
     * Need to post a question and find out what exactly is happening.
     */
    userEmail = userEmail != null ? userEmail : loggedUserEmail;

    return (
        <>
            <div className={"ui middle aligned center aligned grid"}>
                <div className={"column"} style={{ maxWidth: 450 }}>
                    <h3 className="ui teal image header">
                        <div className={"content"}>
                            Tell us how to help! &nbsp; &nbsp;
                            {(container === "modal") ?
                                <span>
                                    <a href={"/contact"}> <i className={"external alternate icon"}></i>  </a>
                                </span> : <></>
                            }
                        </div>
                    </h3>
                    <form className="ui large form">

                        {submitted ?
                            (<p>
                                Thank you! We will get back as soon as possible!
                            </p>) :
                            (<div className={"ui stacked segment"}>
                                <div className={"field"}>
                                    <div className={"ui left icon input"}>
                                        <i className={"user icon"}></i>
                                        <input
                                            type={"text"}
                                            placeholder={loggedUserEmail}
                                            value={userEmail}
                                            onChange={(e) => setUserEmail(e.target.value)}/>
                                    </div>
                                </div>
                                <div className={"field"}>
                                    <div className={"ui left icon input"}>
                                        <textarea
                                            placeholder="Questions, Concerns or Comments ..."
                                            rows="6"
                                            value={userComment}
                                            onChange={(e) => setUserComment(e.target.value)}/>
                                    </div>

                                    {spinner ? (
                                        <div className={"ui fluid large teal loading button"}>
                                            Submitting ...
                                        </div>) : (
                                        <div className={"ui fluid large teal submit button"} onClick={() => {

                                            /* Invoke the redux action to actually post the message*/
                                            postUserFeedback(userEmail, userComment);
                                            setSpinner(true);
                                            setTimeout(() => {
                                                setSpinner(false);
                                                setUserComment('');
                                                setSubmitted(true);
                                            }, 3000);}}>
                                            Submit
                                        </div>)
                                    }
                                </div>
                            </div>)
                        }
                    </form>
                </div>
            </div>
        </>
    )
}
